import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const BUYERS = [{
  name: 'María L.',
  city: 'Córdoba'
}, {
  name: 'Luciana G.',
  city: 'Rosario'
}, {
  name: 'Carolina M.',
  city: 'Buenos Aires'
}, {
  name: 'Andrea P.',
  city: 'Mendoza'
}, {
  name: 'Gabriela R.',
  city: 'Tucumán'
}, {
  name: 'Sofía T.',
  city: 'Salta'
}, {
  name: 'Valeria C.',
  city: 'Neuquén'
}, {
  name: 'Julieta S.',
  city: 'Mar del Plata'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay - longer before first popup
    const initialTimer = setTimeout(() => setIsVisible(true), 8000);
    // Cycle logic - less frequent
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % BUYERS.length);
        setIsVisible(true);
      }, 3000); // Wait 3s before showing next
    }, 15000); // Show for 12s, hide for 3s
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-285">
      <AnimatePresence data-id="element-286">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} className="bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-center gap-4 max-w-xs pointer-events-auto" data-id="element-287">
            <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-288">
              <CheckCircle className="w-6 h-6 text-green-600" data-id="element-289" />
            </div>
            <div data-id="element-290">
              <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-291">
                <span className="font-bold" data-id="element-292">{BUYERS[currentIndex].name}</span>{' '}
                de {BUYERS[currentIndex].city} compró el MEGA KIT DE
                LECTOESCRITURA
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-293">hace unos minutos</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}